import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Artifisettings } from "api/IProduct";

interface ProductCustomizationState {
  details: {
    ZnodeMyLockerProductCustomizationDetailsId: number;
    ProductId: number;
    ProductName: string;
    SKU: string;
    ConfigurationName: string;
    GroupName: string;
    UserId: number;
    DesignId: string;
    ProductCustomizationJson: string;
    ImageLargePath: string | null;
    ImageMediumPath: string | null;
    ImageThumbNailPath: string | null;
    ImageSmallPath: string | null;
    ImageSmallThumbnailPath: string | null;
    CreatedBy: number;
    CreatedDate: string;
    ModifiedBy: number;
    ModifiedDate: string;
    ActionMode: string | null;
    Custom1: string | null;
    Custom2: string | null;
    Custom3: string | null;
    Custom4: string | null;
    Custom5: string | null;
  } | null;
  artifConfigurations:Artifisettings | undefined;
}

const initialState: ProductCustomizationState = {
  details: null,
  artifConfigurations: undefined
};

const productCustomizationSlice = createSlice({
  name: "productCustomization",
  initialState,
  reducers: {
    setProductCustomizationDetails: (
      state,
      action: PayloadAction<ProductCustomizationState["details"]>
    ) => {
      state.details = action.payload;
    },
    setArtifiConfigurationsRedux:(
      state,
      action
    )=>{
      state.artifConfigurations=action.payload;
    }
  },
});

export const {setProductCustomizationDetails,
  setArtifiConfigurationsRedux 
} = productCustomizationSlice.actions;
export default productCustomizationSlice.reducer;